import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12.5 5s-5 3.682-5 5 5 5 5 5"
    }, null, -1)
  ])]);
}
const ChevronLeftIcon = { render };
export {
  ChevronLeftIcon as default,
  render
};
//# sourceMappingURL=chevron-left.svg.js.map
